import { LoadingButton } from "@mui/lab";
import {
  Box,
  ButtonBase,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { styled as styling } from "@mui/material/styles";
import { withTheme } from "@mui/styles";
import styled, { css } from "styled-components";
import Color from "../../../../assets/colors";

export const EmptyContainer = styling(Box)((props) => ({
  "&.MuiContainer-root": {
    padding: "0px",
  },
  padding: "0px",
}));

export const BodyTypographyStyled = styling(Typography)({
  color: "#000000",
  fontWeight: "400",
  fontSize: "16px",
});

export const DialogStyled = styling(Dialog)((props) => ({
  "& .MuiDialog-paper": {
    minWidth: "700px",
    maxHeight: "662px",
    minHeight: "662px",
    borderRadius: "24px",
    border: "2px solid black",

    [props.theme.breakpoints.down("sm")]: {
      minWidth: "328px",
      maxWidth: "328px",
      maxHeight: "490px",
      minHeight: "490px",
    },
  },
}));

export const DialogTitleStyled = styling(DialogTitle)((props) => ({
  borderBottom: `1px solid ${Color.secondaryGrey}`,
  fontSize: "18px",

  [props.theme.breakpoints.down("sm")]: {
    fontSize: "16px",
    lineHeight: "22px",
  },
}));

export const DialogContentStyled = styling(DialogContent)((props) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "16px",
  textAlign: "center",
  overflow: "scroll",
  overflowX: "hidden",
  padding: "0px 24px",

  [props.theme.breakpoints.down("sm")]: {
    alignItems: "flex-start",
    textAlign: "left",
    marginTop: "16px",
  },
}));

export const DialogFormContainer = styling(DialogContent)((props) => ({
  overflow: "scroll",
  overflowX: "hidden",
  padding: "24px",

  [props.theme.breakpoints.down("sm")]: {
    padding: "0px 12px",
  },
}));

export const DialogMainStyled = styling(DialogContentText)((props) => ({
  color: "#321C7B",
  width: "50%",
  fontSize: "32px",
  fontWeight: "700",
  lineHeight: "40px",
  marginBottom: "16px",

  [props.theme.breakpoints.down("sm")]: {
    width: "80%",
    lineHeight: "24px",
    fontSize: "20px",
    marginBottom: "0px",
  },
}));

export const DialogText = styling(DialogContentText)((props) => ({
  color: Color.black,
  width: "80%",
  fontSize: "16px",

  [props.theme.breakpoints.down("sm")]: {
    width: "100%",
    fontSize: "14px",
  },
}));

export const DialogBold = styling("b")({
  fontWeight: "700",
});

export const DialogSubtitle = styling("p")({
  color: Color.black,
  opacity: "0.6",
  fontWeight: "400",
  fontSize: "14px",
  margin: "0",
});

export const DialogInfoContainer = styling(Box)((props) => ({
  backgroundColor: Color.lightPurple,
  color: "#321C7B",
  borderRadius: "8px",
  padding: "28px 22px",

  [props.theme.breakpoints.down("sm")]: {
    padding: "18px 16px",
  },
}));

export const DialogInfoText = styling(DialogContentText)((props) => ({
  color: "#321C7B",
  fontSize: "16px",
  margin: "0px auto",

  [props.theme.breakpoints.down("sm")]: {
    width: "100%",
    fontSize: "14px",
  },
}));

export const DialogActionsStyled = styling(DialogActions)((props) => ({
  "&.MuiDialogActions-root": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  borderTop: `1px solid ${Color.secondaryGrey}`,

  [props.theme.breakpoints.down("sm")]: {
    padding: "14px 8px",
  },
}));

export const StyledLink = styled.a`
  && {
    color: ${Color.hiredlyPurple};
    font-size: "0.8rem";
    display: inline;
  }
`;

export const LabelStyled = withTheme(styled(Typography)`
  && {
    font-weight: ${(props) => (props.caption == "true" ? "normal" : "700")};
    font-size: ${(props) => (props.caption == "true" ? "0.875rem" : "1.5rem")};

    ${(props) =>
      props.divider_text == "true" && {
        color: `${Color.secondaryGrey}`,
        margin: "0 10px",
      }};

    ${(props) =>
      props.disclaimer == "true" && {
        fontWeight: "normal",
        fontStyle: "italic",
        fontSize: "0.7rem",
        margin: "8px 0",
        textAlign: "center",
        whiteSpace: "normal",
      }};

    ${(props) => props.theme.breakpoints.down("mobileL")} {
      ${(props) =>
        props.log_in_button == "true" &&
        css`
          margin: 0;
        `}
    }
  }
`);

export const LoadingButtonStyled = styling(LoadingButton)({
  backgroundColor: Color.black,
  color: Color.white,
  borderRadius: "100px",
  height: "42px",
  textTransform: "none",
  width: "150px",
  fontSize: "16px",
  fontWeight: "700",

  ":hover": {
    backgroundColor: Color.black,
    color: Color.white,
  },

  ":disabled": {
    backgroundColor: "#D8D8D8",
    color: Color.white,
  },
});

export const CompleteButton = styling(ButtonBase)((props) => ({
  border: Color.black + " 2px solid",
  backgroundColor: Color.black,
  color: Color.white,
  borderRadius: "100px",
  padding: "10px 28px",
  fontSize: "16px",
  fontWeight: "700",

  "&:hover": {
    transition: "all 0.25s ease-in-out",
    backgroundColor: "#321C7B",
  },

  [props.theme.breakpoints.down("sm")]: {
    fontSize: "12px",
    padding: "6px 8px",
  },
}));
